(function () {
  "use strict";

  function syncRadios() {
    var path = window.location.pathname.toLowerCase().replace(/\/$/, "");
    document.querySelectorAll(".cdh-premium-selector__radio").forEach(function (radio) {
      var handle = radio.dataset.bundleHandle;
      if (handle && path.includes(handle)) radio.checked = true;
    });
  }

  function init() {
    syncRadios();
    document
      .querySelectorAll(".cdh-premium-selector")
      .forEach(function (container) {
        var widget = container.closest("[data-theme-editor]");
        var isThemeEditor = widget && widget.dataset.themeEditor === "true";

        container.addEventListener("change", function (e) {
          if (!e.target.classList.contains("cdh-premium-selector__radio") || !e.target.checked)
            return;
          if (isThemeEditor || (window.Shopify && window.Shopify.designMode)) return;

          var label = container.querySelector(
            'label[for="' + e.target.id + '"]',
          );
          var redirect = label && label.querySelector(".cdh-hidden-redirect");
          var url =
            redirect &&
            (redirect.getAttribute("data-href") ||
              redirect.getAttribute("href"));

          if (url) window.location.href = url;
        });

        container.addEventListener("click", function (e) {
          e.stopPropagation();
        });
      });
  }

  window.addEventListener("pageshow", function (e) {
    if (e.persisted) syncRadios();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
